module.exports = __webpack_public_path__ + "img/abc1728330ac5053bb9b471adafadf17.png";